import React, { createContext, useContext, useState } from 'react';
import MovieNoriJapan from '../assets/teriyaki.mp4';

const RestaurantsContext = createContext();

export const useRestaurants = () => useContext(RestaurantsContext);

export const RestaurantsProvider = ({ children }) => {
    const [restaurantData, setRestaurantData] = useState({});

    // Define your restaurant data here
    const restaurants = {
        basilthai: {
            name: 'Basil Thai',
            description: 'A wonderful Thai cuisine experience.',
            videos: "",
            doordash: "https://order.online/business/basil-thai-779954",
            locations: [
              { lat: 33.5893, lng: -84.3480, name: 'Basil Thai Kitchen Morrow', address: '1000 Southlake Circle Suite 1205, Morrow, GA 30260, USA' },
              { lat: 35.3400, lng: -119.0226, name: 'Basil Thai Kitchen Bakersfield', address: '2701 Ming Ave, Bakersfield, CA 93304, USA' },
              { lat: 34.2289, lng: -118.5362, name: 'Basil Thai Kitchen Northridge', address: 'Northridge Fashion Center, 9301 Tampa Ave., Northridge, CA 91324, United States', doordash: 'https://order.online/store/basil-thai-los-angeles-28337924/?hideModal=true&pickup=true' },
              { lat: 40.1300, lng: -88.2447, name: 'Basil Thai Kitchen Champaign', address: 'Market Place Shopping Center, 2000 N Neil St, Champaign, IL 61820, United States', doordash: 'https://order.online/store/basil-thai-champaign-897589/?hideModal=true&pickup=true' },
              { lat: 32.5073, lng: -84.9401, name: 'Basil Thai Kitchen Columbus', address: 'Peachtree Mall, 3131 Manchester Expy, Columbus, GA 31909, United States' },
              { lat: 33.7335, lng: -84.7376, name: 'Basil Thai Kitchen Douglasville', address: 'Arbor Place Mall, 6700 Douglas Blvd., Douglasville, GA 30135 United States' },
              { lat: 41.5568, lng: -73.0431, name: 'Basil Thai Kitchen Waterbury', address: 'Brass Mill Mall, 495 Union St., Waterbury, CT 06706, United States' },
              { lat: 39.0010, lng: -84.6504, name: 'Basil Thai Kitchen Florence', address: 'Florence Mall, 2028 Florence Mall, Florence, KY 41042, United States' },
              { lat: 32.0035, lng: -81.1283, name: 'Basil Thai Kitchen Savannah', address: '7804 Abercorn Extention FC-11, Savannah,GA 31406, United States', doordash: 'https://order.online/store/basil-thai-savannah-28337925/?hideModal=true&pickup=true' },
              { lat: 33.3806, lng: -86.8096, name: 'Basil Thai Kitchen Birmingham', address: 'Riverchase Galleria, 2000 Galleria Cir, Birmingham, AL 35244, United States', doordash: 'https://order.online/store/basil-thai-hoover-1267166/?hideModal=true&pickup=true' },
              { lat: 36.0526, lng: -79.8289, name: 'Basil Thai Kitchen Greensboro', address: 'Four Seasons Town Center, 410 Four Seasons Town Centre, Greensboro, NC 27407, United States', doordash: 'https://order.online/store/basil-thai-greensboro-1326573/?hideModal=true&pickup=true' },
              { lat: 37.5053, lng: -77.6042, name: 'Basil Thai Kitchen Richmond', address: 'Chesterfield Town Center, 11500 Midlothian Turnpike, Richmond, VA 23235, United States', doordash: 'https://order.online/store/basil-thai-richmond-1354516/?hideModal=true&pickup=true' },
              { lat: 35.9049, lng: -78.9408, name: 'Basil Thai Kitchen Durham', address: '6810 Fayetteville Rd, Durham, NC', doordash: 'https://order.online/store/basil-thai-durham-1189059/?hideModal=true&pickup=true' },
              { lat: 33.9356, lng: -118.1194, name: 'Basil Thai Kitchen Downey', address: '251 Stonewood St, Downey, CA 90241, United States', doordash: 'https://www.doordash.com/store/basil-thai-downey-32846647/?srsltid=AfmBOoqu0wky2TTZwiFmIVfLyqYwmFYuHHmI3m0YVbcTpwNrA3ejDDc0' },
            ],
            menu: {
                ComboMeal: [
                  {
                    name: 'Combo 1',
                    description: 'Any one entrée with one side',
                    detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
                    detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Combo 2',
                    description: 'Any two entrée with one side',
                    detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
                    detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
                    price: 7.99,
                    image: 'path/to/satay-chicken.jpg'
                  },
                  {
                    name: 'Combo 3',
                    description: 'Any three entrée with one side',
                    detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
                    detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
                    price: 7.99,
                    image: 'path/to/satay-chicken.jpg'
                  },
                ],
                ChefSpecial: [
                  {
                    name: 'Chef\'s Special',
                    description: 'Any one entrée with one side and one egg roll',
                    price: 12.99,
                    image: 'path/to/pad-thai.jpg'
                  },
                ],
                NoodleBar: [
                  {
                    name: 'Tokatsu',
                    description: 'Ramen or Udon',
                    price: 6.99,
                    image: 'path/to/mango-sticky-rice.jpg'
                  },
                  {
                    name: 'Chicken',
                    description: 'Ramen or Udon',
                    price: 6.99,
                    image: 'path/to/mango-sticky-rice.jpg'
                  },
                  {
                    name: 'Beef',
                    description: 'Ramen or Udon',
                    price: 6.99,
                    image: 'path/to/mango-sticky-rice.jpg'
                  },
                  {
                    name: 'Seafood',
                    description: 'Ramen or Udon',
                    price: 6.99,
                    image: 'path/to/mango-sticky-rice.jpg'
                  },
                ],
                Beverages: [
                    {
                      name: 'Milk Tea',
                      description: 'Taro Tea, Thai Tea, Creamy Coconut, Japanese Matcha, Black Milk Tea',
                      price: 6.99,
                      image: 'path/to/mango-sticky-rice.jpg'
                    },
                    {
                      name: 'Fruit Tea',
                      description: 'Mango Tea, Strawberry Tea, Passion Fruit Tea, Honey Lemon Tea',
                      price: 6.99,
                      image: 'path/to/mango-sticky-rice.jpg'
                    },
                    {
                      name: 'Soft Drinks',
                      description: '',
                      price: 6.99,
                      image: 'path/to/mango-sticky-rice.jpg'
                    },
                    {
                      name: 'Bottle Drinks',
                      description: '',
                      price: 6.99,
                      image: 'path/to/mango-sticky-rice.jpg'
                    },
                ],
                SideOrder: [
                    {
                      name: 'Spring Roll',
                      description: '',
                      price: 12.99,
                      image: 'path/to/pad-thai.jpg'
                    },
                                        {
                      name: 'Egg Roll',
                      description: '',
                      price: 13.99,
                      image: 'path/to/green-curry.jpg'
                    },
                    {
                      name: 'Crab Rangoon (4)',
                      description: '',
                      price: 13.99,
                      image: 'path/to/green-curry.jpg'
                    },
                    {
                      name: 'Fried Rice / Lo Mein',
                      description: 'Stir-fried Rice or Lo Mein noodles',
                      price: 12.99,
                      image: 'path/to/pad-thai.jpg'
                    },
                    {
                      name: 'Vegetables Entree',
                      description: 'Mixed Veggies',
                      price: 12.99,
                      image: 'path/to/pad-thai.jpg'
                    },
                    {
                      name: 'Single Entree',
                      description: 'Single Meat of Your Choice',
                      detailedDescription: 'Choice of Meat includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp',
                      price: 13.99,
                      image: 'path/to/green-curry.jpg'
                    },
                  ],
              },
              review: [
                {
                  url: 'https://www.yelp.com/biz/basil-thai-kitchen-douglasville', 
                  name: 'Evan L.', 
                  star: 5, 
                  review: 'I\'ve always wanted to try ramen so I ordered a pork belly ramen for the first time. The owner was very friendly and offered me so many options, as it was my first time ordering it. They had seaweed, corn, soft-boiled egg, green onions, etc. The portion was bigger than I thought. I almost couldn\'t finish the whole bowl. And it tasted very nicely! I will definitely come back again.'
                },
                {
                  url: 'https://www.yelp.com/biz/basil-thai-kitchen-columbus',
                  name: 'Ashley M.',
                  star: 5,
                  review: 'Many selections of meat, plus they have green beans and veggies as sides if you need a more health friendly meal. The meat is very tender, and they allow you to sample before you buy!'
                },
                {
                  url: 'https://www.yelp.com/biz/basil-thai-kitchen-los-angeles?rr=5',
                  name: 'Leslie M.',
                  star: 5,
                  review: 'Food was very good, tasted fresh and it\'s not oily at all. Lots of variety to choose from. Looking forward to trying more of their menu items.'
                },
                {
                  url: 'https://www.yelp.com/biz/basil-thai-kitchen-los-angeles?rr=5',
                  name: 'Timothy M.',
                  star: 5,
                  review: 'I absolutely love their Thai basil chicken. Great noodles. Their service is always great.'
                },
                {
                  url: 'https://www.yelp.com/biz/basil-thai-kitchen-birmingham?rr=5',
                  name: 'David O.',
                  star: 5,
                  review: 'Food was really good especially for Food Court food. Service was very good. I enjoyed it a lot and will definitely return.'
                },

              ]
            // Add more fields like images, videos, menus, etc.
        },
        rubythai: {
          name: 'Ruby Thai',
          description: 'A wonderful Thai cuisine experience.',
          videos: "",
          doordash: "https://order.online/business/ruby-thai-kitchen-12871999",
          locations: [
            { lat: 33.5893, lng: -84.3480, name: 'Basil Thai Kitchen Morrow', address: '1000 Southlake Circle Suite 1205, Morrow, GA 30260, USA' },
            { lat: 35.9049, lng: -78.9408, name: 'Basil Thai Kitchen Durham', address: '6810 Fayetteville Rd, Durham, NC', doordash: 'https://order.online/store/basil-thai-durham-1189059/?hideModal=true&pickup=true' }
          ],
          menu: {
              ComboMeal: [
                {
                  name: 'Combo 1',
                  description: 'Any one entrée with one side',
                  detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
                  detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Combo 2',
                  description: 'Any two entrée with one side',
                  detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
                  detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
                  price: 7.99,
                  image: 'path/to/satay-chicken.jpg'
                },
                {
                  name: 'Combo 3',
                  description: 'Any three entrée with one side',
                  detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
                  detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
                  price: 7.99,
                  image: 'path/to/satay-chicken.jpg'
                },
              ],
              ChefSpecial: [
                {
                  name: 'Chef\'s Special',
                  description: 'Any one entrée with one side and one egg roll',
                  price: 12.99,
                  image: 'path/to/pad-thai.jpg'
                },
              ],
              NoodleBar: [
                {
                  name: 'Tokatsu',
                  description: 'Ramen or Udon',
                  price: 6.99,
                  image: 'path/to/mango-sticky-rice.jpg'
                },
                {
                  name: 'Chicken',
                  description: 'Ramen or Udon',
                  price: 6.99,
                  image: 'path/to/mango-sticky-rice.jpg'
                },
                {
                  name: 'Beef',
                  description: 'Ramen or Udon',
                  price: 6.99,
                  image: 'path/to/mango-sticky-rice.jpg'
                },
                {
                  name: 'Seafood',
                  description: 'Ramen or Udon',
                  price: 6.99,
                  image: 'path/to/mango-sticky-rice.jpg'
                },
              ],
              Beverages: [
                  {
                    name: 'Milk Tea',
                    description: 'Taro Tea, Thai Tea, Creamy Coconut, Japanese Matcha, Black Milk Tea',
                    price: 6.99,
                    image: 'path/to/mango-sticky-rice.jpg'
                  },
                  {
                    name: 'Fruit Tea',
                    description: 'Mango Tea, Strawberry Tea, Passion Fruit Tea, Honey Lemon Tea',
                    price: 6.99,
                    image: 'path/to/mango-sticky-rice.jpg'
                  },
                  {
                    name: 'Soft Drinks',
                    description: '',
                    price: 6.99,
                    image: 'path/to/mango-sticky-rice.jpg'
                  },
                  {
                    name: 'Bottle Drinks',
                    description: '',
                    price: 6.99,
                    image: 'path/to/mango-sticky-rice.jpg'
                  },
              ],
              SideOrder: [
                  {
                    name: 'Spring Roll',
                    description: '',
                    price: 12.99,
                    image: 'path/to/pad-thai.jpg'
                  },
                                      {
                    name: 'Egg Roll',
                    description: '',
                    price: 13.99,
                    image: 'path/to/green-curry.jpg'
                  },
                  {
                    name: 'Crab Rangoon (4)',
                    description: '',
                    price: 13.99,
                    image: 'path/to/green-curry.jpg'
                  },
                  {
                    name: 'Fried Rice / Lo Mein',
                    description: 'Stir-fried Rice or Lo Mein noodles',
                    price: 12.99,
                    image: 'path/to/pad-thai.jpg'
                  },
                  {
                    name: 'Vegetables Entree',
                    description: 'Mixed Veggies',
                    price: 12.99,
                    image: 'path/to/pad-thai.jpg'
                  },
                  {
                    name: 'Single Entree',
                    description: 'Single Meat of Your Choice',
                    detailedDescription: 'Choice of Meat includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp',
                    price: 13.99,
                    image: 'path/to/green-curry.jpg'
                  },
                ],
            },
            review: [
              {
                url: 'https://www.yelp.com/biz/basil-thai-kitchen-douglasville', 
                name: 'Evan L.', 
                star: 5, 
                review: 'I\'ve always wanted to try ramen so I ordered a pork belly ramen for the first time. The owner was very friendly and offered me so many options, as it was my first time ordering it. They had seaweed, corn, soft-boiled egg, green onions, etc. The portion was bigger than I thought. I almost couldn\'t finish the whole bowl. And it tasted very nicely! I will definitely come back again.'
              },
              {
                url: 'https://www.yelp.com/biz/basil-thai-kitchen-columbus',
                name: 'Ashley M.',
                star: 5,
                review: 'Many selections of meat, plus they have green beans and veggies as sides if you need a more health friendly meal. The meat is very tender, and they allow you to sample before you buy!'
              },
              {
                url: 'https://www.yelp.com/biz/basil-thai-kitchen-los-angeles?rr=5',
                name: 'Leslie M.',
                star: 5,
                review: 'Food was very good, tasted fresh and it\'s not oily at all. Lots of variety to choose from. Looking forward to trying more of their menu items.'
              },
              {
                url: 'https://www.yelp.com/biz/basil-thai-kitchen-los-angeles?rr=5',
                name: 'Timothy M.',
                star: 5,
                review: 'I absolutely love their Thai basil chicken. Great noodles. Their service is always great.'
              },
              {
                url: 'https://www.yelp.com/biz/basil-thai-kitchen-birmingham?rr=5',
                name: 'David O.',
                star: 5,
                review: 'Food was really good especially for Food Court food. Service was very good. I enjoyed it a lot and will definitely return.'
              },

            ]
          // Add more fields like images, videos, menus, etc.
      },
        sakejapan: {
            name: 'Sake Japan',
            description: 'Authentic Japanese cuisine with a modern twist.',
            videos: '',
            doordash: 'https://order.online/business/sake-japan-304460',
            locations: [
              { lat: 30.4033, lng: -91.0942, name: 'Sake Japan Baton Rouge', address: 'Louisiana Mall, 6401 Bluebonnet Blvd, Baton Rouge, LA 70836, United States' },
              { lat: 33.9147, lng: -117.4566, name: 'Sake Japan Riverside', address: 'Galleria Mall, 1299 Galleria at Tyler, Riverside, CA 92503, United States' },
              { lat: 35.9049, lng: -78.9394, name: 'Sake Japan Durham', address: 'South Point Mall, 6810 Fayetteville Rd., Durham, NC 27713, United States' },
              { lat: 33.5893, lng: -84.3480, name: 'Sake Japan Morrow', address: '1000 Southlake Cir, Morrow GA', doordash: 'https://order.online/store/sake-japan-morrow-1326541/?hideModal=true&pickup=true' }
          ],
            menu: {
                Sushi: [
                    {
                      name: 'California Roll',
                      description: 'Imitation Crab, Cucumber and Avocado',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                    {
                      name: 'Shrimp Tempura Roll',
                      description: 'Tempura Shrimp, Avocado and Imitation Crab',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                    {
                      name: 'Tiger Roll',
                      description: 'Shrimp Tempura, Cucumber and Imitation Crab. Topped with Spicy Tuna, Spicy Mayo and Eel Sauce',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                    {
                      name: 'Dragon Roll',
                      description: 'Cucumber and Avocado. Topped with Eel and eel sauce',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                  ],
                BentoBox: [
                  {
                    name: 'Chicken Bento',
                    description: 'Served with Steamed Rice or Fried Rice + Mixed Vegetables + California Roll [4 pcs] + Dumplings [3 pcs]',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Steak Bento',
                    description: 'Served with Steamed Rice or Fried Rice + Mixed Vegetables + California Roll [4 pcs] + Dumplings [3 pcs]',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Shrimp Bento',
                    description: 'Served with Steamed Rice or Fried Rice + Mixed Vegetables + California Roll [4 pcs] + Dumplings [3 pcs]',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                ],
                SignatureTeriyaki: [
                    {
                      name: 'Chicken Teriyaki',
                      description: 'Served with Steamed Rice or Fried Rice + Mixed Vegetables',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                    {
                      name: 'Steak Teriyaki',
                      description: 'Served with Steamed Rice or Fried Rice + Mixed Vegetables',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                    {
                      name: 'Shrimp Teriyaki',
                      description: 'Served with Steamed Rice + Mixed Vegetables',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                    {
                      name: 'Chicken + Shrimp Teriyaki',
                      description: 'Served with Steamed Rice + Mixed Vegetables',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                    {
                      name: 'Chicken + Beef Teriyaki',
                      description: 'Served with Steamed Rice + Mixed Vegetables',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                    {
                      name: 'Beef + Shrimp Teriyaki',
                      description: 'Served with Steamed Rice + Mixed Vegetables',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                  ],
                  Appetizer: [
                    {
                      name: 'Shrimp Tempura (3pcs) ',
                      description: '',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                    {
                      name: 'Takoyaki (5pcs) ',
                      description: '',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                    {
                      name: 'Chicken Gyoza (6pcs) ',
                      description: '',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                    {
                        name: 'Veggie Spring Roll (2pcs) ',
                        description: '',
                        price: 5.99,
                        image: 'path/to/spring-rolls.jpg'
                    },
                    {
                        name: 'Egg Roll (1pc) ',
                        description: '',
                        price: 5.99,
                        image: 'path/to/spring-rolls.jpg'
                    },
                  ],
                  SideChoice: [
                    {
                      name: 'Meat Entree',
                      description: '',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                    {
                      name: 'Steamed Rice',
                      description: '',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                    {
                      name: 'Fried Rice',
                      description: '',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                    {
                      name: 'Lo Mein Noodle',
                      description: '',
                      price: 5.99,
                      image: 'path/to/spring-rolls.jpg'
                    },
                  ],
            },
            review: [
              {
                url: 'https://www.google.com/search?q=Sake+Japan+rock+hill&sca_esv=0871ff21afb3ee13&sca_upv=1&sxsrf=ADLYWIKU_sYUArsu-QVOWwRsh5rGIPGbJw%3A1725837048175&ei=-C7eZre5CtW4wN4P_7X8wAE&ved=0ahUKEwi3lcmBvLSIAxVVHNAFHf8aHxgQ4dUDCBE&uact=5&oq=Sake+Japan+rock+hill&gs_lp=Egxnd3Mtd2l6LXNlcnAiFFNha2UgSmFwYW4gcm9jayBoaWxsMhEQLhiABBiRAhjHARiKBRivATIGEAAYFhgeMgsQABiABBiGAxiKBTILEAAYgAQYhgMYigUyCxAAGIAEGIYDGIoFMgsQABiABBiGAxiKBTILEAAYgAQYhgMYigUyCBAAGIAEGKIEMggQABiABBiiBDIIEAAYgAQYogQyIBAuGIAEGJECGMcBGIoFGK8BGJcFGNwEGN4EGOAE2AEBSOobUKcRWKIZcAJ4AZABAJgBhwGgAbUIqgEDMS44uAEDyAEA-AEBmAILoAL4CMICBxAjGLADGCfCAgoQABiwAxjWBBhHwgIEECMYJ8ICChAjGIAEGCcYigXCAgUQABiABMICCxAuGIAEGMcBGK8BwgIIEAAYogQYiQWYAwCIBgGQBge6BgYIARABGBSSBwMzLjigB4Ff&sclient=gws-wiz-serp#lrd=0x88568622f33b1a5d:0x5ecca75cd4ca35d4,1,,,,', 
                name: 'Arica B.', 
                star: 5, 
                review: 'I absolutely love this place! I’ve been coming here for about 2 years and have never had a bad experience or meal. Their rice is so fresh and fluffy, veggies are cooked perfectly. Everything is seasoned great. It’s always so fresh and doesn’t give you that “blah” too full feeling afterwards. They are so nice and friendly. They cook your food right on the spot and fast. If you’re a regular costumer.. they remember you and what you order, and treat you almost like family! Definitely worth checking out!'
              },
              {
                url: 'https://www.google.com/search?q=Sake+Japan+rock+hill&sca_esv=0871ff21afb3ee13&sca_upv=1&sxsrf=ADLYWIKU_sYUArsu-QVOWwRsh5rGIPGbJw%3A1725837048175&ei=-C7eZre5CtW4wN4P_7X8wAE&ved=0ahUKEwi3lcmBvLSIAxVVHNAFHf8aHxgQ4dUDCBE&uact=5&oq=Sake+Japan+rock+hill&gs_lp=Egxnd3Mtd2l6LXNlcnAiFFNha2UgSmFwYW4gcm9jayBoaWxsMhEQLhiABBiRAhjHARiKBRivATIGEAAYFhgeMgsQABiABBiGAxiKBTILEAAYgAQYhgMYigUyCxAAGIAEGIYDGIoFMgsQABiABBiGAxiKBTILEAAYgAQYhgMYigUyCBAAGIAEGKIEMggQABiABBiiBDIIEAAYgAQYogQyIBAuGIAEGJECGMcBGIoFGK8BGJcFGNwEGN4EGOAE2AEBSOobUKcRWKIZcAJ4AZABAJgBhwGgAbUIqgEDMS44uAEDyAEA-AEBmAILoAL4CMICBxAjGLADGCfCAgoQABiwAxjWBBhHwgIEECMYJ8ICChAjGIAEGCcYigXCAgUQABiABMICCxAuGIAEGMcBGK8BwgIIEAAYogQYiQWYAwCIBgGQBge6BgYIARABGBSSBwMzLjigB4Ff&sclient=gws-wiz-serp#lrd=0x88568622f33b1a5d:0x5ecca75cd4ca35d4,1,,,,',
                name: 'Lauren A.',
                star: 5,
                review: 'I love this place. It’s always fast, the food is great, and the woman there is always so sweet (sorry I don’t know her name!) I highly recommend this place. I always get the teriyaki chicken bento box, and lemme tell you, it SLAPS 🤤'
              },
              {
                url: '',
                name: 'Zhaoxing L.',
                star: 5,
                review: 'This is one of the best sushi dishes I\'ve ever seen! Fish are very fresh and sweet, my family like to eat this sushi, the child will cry a day without eating. It deserves five stars'
              },
              {
                url: '',
                name: 'Stella L.',
                star: 5,
                review: 'I am usually skeptical of sushi places in the shopping mall, but this little sushi place has been around for years, and never fail! Every time the food is fresh and rice is warm, and over the years they have added more items to their menu which all very good. We have ordered sushi rolls, poke bowls, bento boxes, etc., each and every one of them turns out to be tasty.'
              },
              {
                url: '',
                name: 'Minfeng L.',
                star: 5,
                review: 'More than ten years old. Trustworthy. Choosing NORI Sushi will not disappoint me.'
              },
            ],

            // Add more fields like images, videos, menus, etc.
        },
        norijapan: {
            name: 'Nori Japan',
            description: 'Authentic Japanese hibachi with a modern twist.',
            videos: MovieNoriJapan,
            doordash: 'https://order.online/business/nori-japan-12859937',
            locations: [
            { lat: 33.4910, lng: -82.0860, name: 'Nori Japan Augusta', address: '260 Bobby Jones Expy, Augusta GA', doordash: 'https://order.online/store/nori-japan-augusta-28412566/?hideModal=true&pickup=true' },
            { lat: 33.9073, lng: -84.1350, name: 'Nori Japan Lilburn', address: '4004 Lawrenceville Hwy NW, Lilburn GA', doordash: 'https://order.online/store/nori-japan-lilburn-30942580/?hideModal=true&pickup=true' },
            { lat: 33.3022, lng: -111.8990, name: 'Nori Japan Chandler', address: '3111 W Chandler Blvd, Chandler AZ', doordash: 'https://order.online/store/nori-japan-chandler-28355566/?hideModal=true&pickup=true' },
            { lat: 32.42381, lng: -84.94511, name: 'Nori Japan Columbus', address: '3515 Victory Dr, Columbus GA 31903', doordash: 'https://www.doordash.com/en/store/nori-japan-columbus-33862171/?hideModal=true&pickup=true' },
            { lat: 32.28855, lng: -110.97390, name: 'Nori Japan Tucson', address: '4500 N Oracle Rd FC02, Tucson, AZ 85705' },
            { lat: 35.70332, lng: -81.28669,  name: 'Nori Japan Hickory', address: '2525 US Hwy 70 SE, Hickory, NC 28602' },
            { lat: 34.19330, lng: -79.82170,  name: 'Nori Japan Florence', address: '230 N Beltline Dr, Florence, SC 29501' },
            { lat: 36.05772, lng: -79.90080,  name: 'Nori Japan Greensboro', address: '4424 W Wendover Ave, Greensboro, NC 27407', doordash: 'https://www.doordash.com/store/nori-japan-greensboro-32922987/?hideModal=true&pickup=true' },
            { lat: 33.91538, lng: -117.88752, name: 'Nori Japan Brea', address: '100 Brea Mall Space 2168, Brea, CA 92821' },
            { lat: 45.6237, lng: -122.5623, name: 'Nori Japan Vancouver', address: 'Walmart Supercenter, 221E NE 104th Ave, Vancouver, WA 98664, United States', doordash: 'https://www.doordash.com/store/nori-japan-vancouver-41854381/?hideModal=true&pickup=true' },
            { lat: 32.5442, lng: -117.0413, name: 'Nori Japan San Diego', address: 'Las Americas Premium Outlets, 4211 Camino De La Plaza, San Diego, CA 92173, United States', doordash: 'https://www.doordash.com/store/nori-japan-san-ysidro-35628537/?hideModal=true&pickup=true' },
          ],
            menu: {
              Sushi: [
                  {
                    name: 'California Roll',
                    description: 'Imitation Crab, Cucumber and Avocado',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Chicken Teriyaki Roll',
                    description: 'Tempura Shrimp, Avocado and Imitation Crab',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Shrimp Tempura Roll',
                    description: 'Shrimp Tempura, Cucumber and Imitation Crab. Topped with Spicy Tuna, Spicy Mayo and Eel Sauce',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Tempura California Roll',
                    description: 'Cucumber and Avocado. Topped with Eel and eel sauce',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Green Dragon Roll',
                    description: 'Cucumber and Avocado. Topped with Eel and eel sauce',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Spider Roll',
                    description: 'Cucumber and Avocado. Topped with Eel and eel sauce',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                ],
              BentoBox: [
                {
                  name: 'Chicken Bento',
                  description: 'Served with Steamed Rice or Fried Rice + Mixed Vegetables + California Roll [4 pcs] + Dumplings [3 pcs]',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Steak Bento',
                  description: 'Served with Steamed Rice or Fried Rice + Mixed Vegetables + California Roll [4 pcs] + Dumplings [3 pcs]',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Shrimp Bento',
                  description: 'Served with Steamed Rice or Fried Rice + Mixed Vegetables + California Roll [4 pcs] + Dumplings [3 pcs]',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
              ],
              FamousTeriyaki: [
                  {
                    name: 'Chicken Teriyaki',
                    description: 'Served with Steamed Rice or Fried Rice + Mixed Vegetables',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Steak Teriyaki',
                    description: 'Served with Steamed Rice or Fried Rice + Mixed Vegetables',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Shrimp Teriyaki',
                    description: 'Served with Steamed Rice + Mixed Vegetables',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Chicken & Shrimp Teriyaki',
                    description: 'Served with Steamed Rice + Mixed Vegetables',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Chicken & Beef Teriyaki',
                    description: 'Served with Steamed Rice + Mixed Vegetables',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Beef & Shrimp Teriyaki',
                    description: 'Served with Steamed Rice + Mixed Vegetables',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                ],
                Appetizer: [
                  {
                    name: 'Shrimp Tempura (3pcs) ',
                    description: '',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Chicken Dumplings (6pcs) ',
                    description: '',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Veggie Spring Roll (2pcs) ',
                    description: '',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Egg Roll (1pc) ',
                    description: '',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                ],
                SideChoice: [
                  {
                    name: 'Meat Entree',
                    description: '',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Steamed Rice',
                    description: '',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Fried Rice',
                    description: '',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                  {
                    name: 'Lo Mein Noodle',
                    description: '',
                    price: 5.99,
                    image: 'path/to/spring-rolls.jpg'
                  },
                ],
          },
          review: [
            {
              url: 'https://www.google.com/search?q=nori+japan&oq=nori+japan&gs_lcrp=EgZjaHJvbWUqBggAEEUYOzIGCAAQRRg7MgYIARBFGDsyBggCEEUYPDIGCAMQRRg8MgYIBBBFGDwyBggFEC4YQNIBCDI0NDZqMGoxqAIAsAIA&sourceid=chrome&ie=UTF-8&lqi=Cgpub3JpIGphcGFuSIuGi5Sou4CACFoUEAAQARgAGAEiCm5vcmkgamFwYW6SARRmYXN0X2Zvb2RfcmVzdGF1cmFudJoBJENoZERTVWhOTUc5blMwVkpRMEZuU1VOSVowOUROR3BSUlJBQqoBTAoIL20vMDVqcnYQASoOIgpub3JpIGphcGFuKAAyHhABIho2aK_0nMFpebbHA1vrzvFTRIqMAJLs6w0iAzIOEAIiCm5vcmkgamFwYW7gAQA#lkt=LocalPoiReviews&rlimm=11760246415690837492', 
              name: 'Michaela A.', 
              star: 5, 
              review: 'I noticed when you search for Boba, this place does not come up, BUT IT SHOULD!!! Great price and quality of Boba!!! Very good customer service, and they\'re quick! Food is great too from what we\'ve tried so far, but this is my regular boba stop now!!!'
            },
            {
              url: 'https://www.google.com/search?q=nori+japan&oq=nori+japan&gs_lcrp=EgZjaHJvbWUqBggAEEUYOzIGCAAQRRg7MgYIARBFGDsyBggCEEUYPDIGCAMQRRg8MgYIBBBFGDwyBggFEC4YQNIBCDI0NDZqMGoxqAIAsAIA&sourceid=chrome&ie=UTF-8&lqi=Cgpub3JpIGphcGFuSIuGi5Sou4CACFoUEAAQARgAGAEiCm5vcmkgamFwYW6SARRmYXN0X2Zvb2RfcmVzdGF1cmFudJoBJENoZERTVWhOTUc5blMwVkpRMEZuU1VOSVowOUROR3BSUlJBQqoBTAoIL20vMDVqcnYQASoOIgpub3JpIGphcGFuKAAyHhABIho2aK_0nMFpebbHA1vrzvFTRIqMAJLs6w0iAzIOEAIiCm5vcmkgamFwYW7gAQA#lkt=LocalPoiReviews&rlimm=11760246415690837492',
              name: 'Aaron Anderson',
              star: 5,
              review: 'Great food, boba, and service! The chicken bento box was DELICIOUS, and I love their sparkling lemon strawberry boba! Love that it\'s conveniently inside of Walmart too!!'
            },
            {
              url: 'https://www.google.com/search?q=nori+japan+augusta&sca_esv=54f696d6495eaa02&sca_upv=1&sxsrf=ADLYWIK0pl0bfC9cx52fTFcFv7jTxxGbCg%3A1725831957560&ei=FRveZpHvIYnAp84Pk7DHgAU&gs_ssp=eJzj4tVP1zc0LMs2qkzOs0gxYLRSMaiwsEizTDFOS042M0kzMTM0tDKoMDNPMjUyNTdMM7ZMMkgx8BLKyy_KVMhKLEjMU0gsTS8tLkkEAABCFeI&oq=nori+japan+&gs_lp=Egxnd3Mtd2l6LXNlcnAiC25vcmkgamFwYW4gKgIIAjIFEAAYgAQyDhAuGIAEGMcBGI4FGK8BMgsQLhiABBjHARivATIKEAAYgAQYFBiHAjIKEAAYgAQYFBiHAjIFEAAYgAQyCxAuGIAEGMcBGK8BMgoQABiABBhDGIoFMgUQABiABDIFEAAYgARIzR5QhQVYhQVwAXgBkAEAmAFnoAFnqgEDMC4xuAEByAEA-AEBmAICoAJywgIKEAAYsAMY1gQYR8ICDRAAGIAEGLADGEMYigXCAhkQLhiABBiwAxjRAxhDGMcBGMgDGIoF2AEBwgIcEC4YgAQYsAMYQxjHARjIAxiKBRiOBRivAdgBAcICExAuGIAEGLADGEMYyAMYigXYAQHCAhkQLhiABBiwAxhDGMcBGMgDGIoFGK8B2AEBmAMAiAYBkAYUugYGCAEQARgIkgcDMS4xoAe_DQ&sclient=gws-wiz-serp#lrd=0x88f9d3fcc64f4611:0x67b52571f39b0d0,1,,,,',
              name: 'Futrell F.',
              star: 5,
              review: 'We ordered 2 chicken bento boxes. The chicken was well seasoned and tasty. The dumplings were stuffed with goodness and they had the right bite. You know that one bite with the crispy edges. Our bento boxses was filled to the rim. We had great customer service and were satisfied. My only regret is not trying the Boba but I will be back. ❤️'
            },
            {
              url: 'https://www.google.com/search?q=nori+japan+augusta&sca_esv=54f696d6495eaa02&sca_upv=1&sxsrf=ADLYWIK0pl0bfC9cx52fTFcFv7jTxxGbCg%3A1725831957560&ei=FRveZpHvIYnAp84Pk7DHgAU&gs_ssp=eJzj4tVP1zc0LMs2qkzOs0gxYLRSMaiwsEizTDFOS042M0kzMTM0tDKoMDNPMjUyNTdMM7ZMMkgx8BLKyy_KVMhKLEjMU0gsTS8tLkkEAABCFeI&oq=nori+japan+&gs_lp=Egxnd3Mtd2l6LXNlcnAiC25vcmkgamFwYW4gKgIIAjIFEAAYgAQyDhAuGIAEGMcBGI4FGK8BMgsQLhiABBjHARivATIKEAAYgAQYFBiHAjIKEAAYgAQYFBiHAjIFEAAYgAQyCxAuGIAEGMcBGK8BMgoQABiABBhDGIoFMgUQABiABDIFEAAYgARIzR5QhQVYhQVwAXgBkAEAmAFnoAFnqgEDMC4xuAEByAEA-AEBmAICoAJywgIKEAAYsAMY1gQYR8ICDRAAGIAEGLADGEMYigXCAhkQLhiABBiwAxjRAxhDGMcBGMgDGIoF2AEBwgIcEC4YgAQYsAMYQxjHARjIAxiKBRiOBRivAdgBAcICExAuGIAEGLADGEMYyAMYigXYAQHCAhkQLhiABBiwAxhDGMcBGMgDGIoFGK8B2AEBmAMAiAYBkAYUugYGCAEQARgIkgcDMS4xoAe_DQ&sclient=gws-wiz-serp#lrd=0x88f9d3fcc64f4611:0x67b52571f39b0d0,1,,,,',
              name: 'Rita M.',
              star: 5,
              review: 'My husband and I ordered chicken teriyaki and wontons chicken was very tender had a lot of flavor Ginger sauce was really good sushi is really good we\'ve been here five times we will keep coming Thank you  😁.'
            },
            {
              url: 'https://www.google.com/search?q=nori+sushi&sca_esv=c4c1450a5839235a&sca_upv=1&biw=1470&bih=794&tbm=lcl&sxsrf=ADLYWIIlrWe2iE7Vtk7ruWlCs2Hf_PULJA%3A1725831681379&ei=ARreZqH2Fua3wN4Pj_qb6Q8&ved=0ahUKEwjh-r2CqLSIAxXmG9AFHQ_9Jv0Q4dUDCAk&uact=5&oq=nori+sushi&gs_lp=Eg1nd3Mtd2l6LWxvY2FsIgpub3JpIHN1c2hpMhEQABiABBiRAhixAxiDARiKBTILEAAYgAQYkQIYigUyCxAAGIAEGJECGIoFMgsQABiABBiRAhiKBTILEAAYgAQYkQIYigUyChAAGIAEGBQYhwIyBRAAGIAEMgUQABiABDIFEAAYgAQyBRAAGIAESODGCVDnwAlYpsQJcAJ4AJABAJgBUqABkAOqAQE2uAEDyAEA-AEBmAIIoAKsA8ICBBAjGCfCAgoQABiABBhDGIoFwgIOEAAYgAQYkQIYsQMYigXCAggQABiABBixA5gDAIgGAZIHATigB8wh&sclient=gws-wiz-local#lkt=LocalPoiReviews&rlfi=hd:;si:;mv:[[36.111338671552346,-78.7881026013316],[33.173662636011485,-84.56505946387693]]',
              name: 'Star B.',
              star: 5,
              review: 'The food is AMAZING! I got it at the mall food court. I dropped the sushi and the lady was so nice to make a whole new batch. It taste awesome and awesome customer service. Only place I will be bringing my money to from now on 🥰'
            },
          ],
            // Add more fields like images, videos, menus, etc.
        },
        norisushi: {
            name: 'Nori Sushi',
            description: 'Authentic Japanese sushi with a modern twist.',
            videos: '',
            doordash: 'https://order.online/business/nori-sushi-11731144',
            locations: [
              { lat: 34.1025, lng: -83.9885, name: 'Nori Sushi Buford', address: '3333 Buford Dr, Buford, GA 30519', doordash: 'https://order.online/store/nori-sushi-buford-25690013/?hideModal=true&pickup=true&redirected=true' }
            ],
            menu: {
              SushiCombos: [
                {
                  name: 'Salmon & Maki',
                  description: '5 pcs raw salmon sashimi + 20 pcs assorted rolls (salmon, tuna, crab & cucumber)',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Vegetarian Zen',
                  description: '4 pcs tofu skin sushi + 10 pcs Vegetarian roll',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Cooked Delight',
                  description: '10 pcs California Roll + 2 pcs shrimp nigiri sushi + 2 pcs crab nigiri sushi',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Sushi & Roll',
                  description: '6 pcs nigiri sushi (salmon, tuna, tilapia, crab, eels & shrimp) + 10 pcs California roll',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Sushi, Sashimi and Roll',
                  description: '6 pcs sashimi (2x salmon, 2x tuna, 2x tilapia) + 4 pcs nigiri sushi (salmon, tuna, tilapia & shrimp) + 10 pcs California Roll',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
              ],
            SushiRolls: [
              {
                name: 'California Roll',
                description: '10 pcs. Imitation Crab, Cucumber and Avocado',
                price: 5.99,
                image: 'path/to/spring-rolls.jpg'
              },
              {
                name: 'Chicken Teriyaki Roll',
                description: '10pcs. Chicken Teriyaki & Avocado. Topped with Eel Sauce',
                price: 5.99,
                image: 'path/to/spring-rolls.jpg'
              },
              {
                name: 'Shrimp Tempura Roll',
                description: '10pcs. Shrimp Tempura & Avocado. Topped with Eel Sauce',
                price: 5.99,
                image: 'path/to/spring-rolls.jpg'
              },
              {
                name: 'Salmon Roll',
                description: '10 pcs Raw Salmon',
                price: 5.99,
                image: 'path/to/spring-rolls.jpg'
              },
              {
                name: 'Salmon Avocado Roll',
                description: '10pcs. Raw Salmon & Avocado',
                price: 5.99,
                image: 'path/to/spring-rolls.jpg'
              },
              {
                name: 'Tuna Roll',
                description: '10 pcs Raw Tuna',
                price: 5.99,
                image: 'path/to/spring-rolls.jpg'
              },
              {
                name: 'Spicy Tuna Roll',
                description: '10pcs. Spicy Raw Tuna & Crunchy Flakes',
                price: 5.99,
                image: 'path/to/spring-rolls.jpg'
              },
              {
                name: 'Philadelphia Roll',
                description: '10pcs. Smoked Salmon, Cream Cheese & Cucumber',
                price: 5.99,
                image: 'path/to/spring-rolls.jpg'
              },
              {
                name: 'Boston Roll',
                description: '10pcs. Steamed Shrimp, Avocado & Cucumber',
                price: 5.99,
                image: 'path/to/spring-rolls.jpg'
              },
              {
                name: 'Vegetable Roll',
                description: '10pcs. Avocado, Cucumber, Carrot & Seaweed Salad',
                price: 5.99,
                image: 'path/to/spring-rolls.jpg'
              },
            ],
            IndividualSushi: [
                {
                  name: 'Salmon',
                  description: '1pc Salmon Nigiri',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Tilapia',
                  description: '1pc Tilapia Nigiri',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Tuna',
                  description: '1pc Tuna Nigiri',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Imitation Crab Meat',
                  description: '1pc Imitation Crab Meat Nigiri',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Eel',
                  description: '1pc Eel Nigiri',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Shrimp',
                  description: '1pc Shrimp Nigiri',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Tofu Skin',
                  description: '1pc Tofu Skin',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
              ],
              SushiHandRoll: [
                {
                  name: 'Salmon Skin',
                  description: 'Salmon Skin wrapped in Seaweed Roll',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Seafood',
                  description: 'Seafood wrapped in Seaweed Roll',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Spicy Tuna',
                  description: 'Spicy Tuna wrapped in Seaweed Roll',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
              ],
              SideOrder: [
                {
                  name: 'Spring Roll',
                  description: '',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Dumplings (6 pcs)',
                  description: '',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Miso Soup',
                  description: '',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
              ],
        },
        review: [
          {
            url: 'https://www.google.com/search?sca_esv=c4c1450a5839235a&sca_upv=1&tbs=lf:1,lf_ui:9&tbm=lcl&sxsrf=ADLYWIL1V28WRGAT-etAg-5_LF45d-8-dw:1725819409133&q=nori+japan&rflfq=1&num=10&sa=X&ved=2ahUKEwj4r8-m-rOIAxXUMNAFHU8eBmQQjGp6BAgjEAE&biw=1470&bih=794&dpr=2#lkt=LocalPoiReviews&rlfi=hd:;si:2664765938569956440,l,Cgpub3JpIGphcGFuSI_p3MuNsYCACFoSEAAQARgAIgpub3JpIGphcGFukgEQc3VzaGlfcmVzdGF1cmFudJoBJENoZERTVWhOTUc5blMwVkpRMEZuU1VOQ2VWcHRPVFJuUlJBQqoBTAoIL20vMDVqcnYQASoOIgpub3JpIGphcGFuKAAyHhABIho2aK_0nMFpebbHA1vrzvFTRIqMAJLs6w0iAzIOEAIiCm5vcmkgamFwYW7gAQA,y,QdPRx4tlAiY;mv:[[34.0745479,-83.96027699999999],[33.8933635,-84.4028257]]', 
            name: 'Yong C.', 
            star: 5, 
            review: 'I\'ve been coming here for years, excellent service and food\'s always made in front of you making it fresh'
          },
          {
            url: 'https://www.google.com/search?q=nori+sushi&sca_esv=c4c1450a5839235a&sca_upv=1&biw=1470&bih=794&tbm=lcl&sxsrf=ADLYWIIlrWe2iE7Vtk7ruWlCs2Hf_PULJA%3A1725831681379&ei=ARreZqH2Fua3wN4Pj_qb6Q8&ved=0ahUKEwjh-r2CqLSIAxXmG9AFHQ_9Jv0Q4dUDCAk&uact=5&oq=nori+sushi&gs_lp=Eg1nd3Mtd2l6LWxvY2FsIgpub3JpIHN1c2hpMhEQABiABBiRAhixAxiDARiKBTILEAAYgAQYkQIYigUyCxAAGIAEGJECGIoFMgsQABiABBiRAhiKBTILEAAYgAQYkQIYigUyChAAGIAEGBQYhwIyBRAAGIAEMgUQABiABDIFEAAYgAQyBRAAGIAESODGCVDnwAlYpsQJcAJ4AJABAJgBUqABkAOqAQE2uAEDyAEA-AEBmAIIoAKsA8ICBBAjGCfCAgoQABiABBhDGIoFwgIOEAAYgAQYkQIYsQMYigXCAggQABiABBixA5gDAIgGAZIHATigB8wh&sclient=gws-wiz-local#lkt=LocalPoiReviews&rlfi=hd:;si:;mv:[[43.53326486569146,-68.68894857684073],[38.121331789078,-74.40454943958922]]', 
            name: 'Claudia M.', 
            star: 5, 
            review: 'Unbelievably good to be a mall sushi! Def best place to eat at if you\'re at the mall'
          },
          {
            url: 'https://www.google.com/search?q=nori+sushi&sca_esv=c4c1450a5839235a&sca_upv=1&biw=1470&bih=794&tbm=lcl&sxsrf=ADLYWIIlrWe2iE7Vtk7ruWlCs2Hf_PULJA%3A1725831681379&ei=ARreZqH2Fua3wN4Pj_qb6Q8&ved=0ahUKEwjh-r2CqLSIAxXmG9AFHQ_9Jv0Q4dUDCAk&uact=5&oq=nori+sushi&gs_lp=Eg1nd3Mtd2l6LWxvY2FsIgpub3JpIHN1c2hpMhEQABiABBiRAhixAxiDARiKBTILEAAYgAQYkQIYigUyCxAAGIAEGJECGIoFMgsQABiABBiRAhiKBTILEAAYgAQYkQIYigUyChAAGIAEGBQYhwIyBRAAGIAEMgUQABiABDIFEAAYgAQyBRAAGIAESODGCVDnwAlYpsQJcAJ4AJABAJgBUqABkAOqAQE2uAEDyAEA-AEBmAIIoAKsA8ICBBAjGCfCAgoQABiABBhDGIoFwgIOEAAYgAQYkQIYsQMYigXCAggQABiABBixA5gDAIgGAZIHATigB8wh&sclient=gws-wiz-local#lkt=LocalPoiReviews&rlfi=hd:;si:;mv:[[43.53326486569146,-68.68894857684073],[38.121331789078,-74.40454943958922]]',
            name: 'Nicole',
            star: 5,
            review: 'This the best sushi I have ever had, every time. I drive all the way down from Revere to get this sushi- it’s that good.'
          },
          {
            url: 'https://www.google.com/search?q=nori+sushi&sca_esv=c4c1450a5839235a&sca_upv=1&biw=1470&bih=794&tbm=lcl&sxsrf=ADLYWIIlrWe2iE7Vtk7ruWlCs2Hf_PULJA%3A1725831681379&ei=ARreZqH2Fua3wN4Pj_qb6Q8&ved=0ahUKEwjh-r2CqLSIAxXmG9AFHQ_9Jv0Q4dUDCAk&uact=5&oq=nori+sushi&gs_lp=Eg1nd3Mtd2l6LWxvY2FsIgpub3JpIHN1c2hpMhEQABiABBiRAhixAxiDARiKBTILEAAYgAQYkQIYigUyCxAAGIAEGJECGIoFMgsQABiABBiRAhiKBTILEAAYgAQYkQIYigUyChAAGIAEGBQYhwIyBRAAGIAEMgUQABiABDIFEAAYgAQyBRAAGIAESODGCVDnwAlYpsQJcAJ4AJABAJgBUqABkAOqAQE2uAEDyAEA-AEBmAIIoAKsA8ICBBAjGCfCAgoQABiABBhDGIoFwgIOEAAYgAQYkQIYsQMYigXCAggQABiABBixA5gDAIgGAZIHATigB8wh&sclient=gws-wiz-local#lkt=LocalPoiReviews&rlfi=hd:;si:;mv:[[43.53326486569146,-68.68894857684073],[38.121331789078,-74.40454943958922]]',
            name: 'Zhaoxing L.',
            star: 5,
            review: 'This is one of the best sushi dishes I\'ve ever seen! Fish are very fresh and sweet, my family like to eat this sushi, the child will cry a day without eating. It deserves five stars'
          },
          {
            url: 'https://www.google.com/search?q=nori+sushi&sca_esv=c4c1450a5839235a&sca_upv=1&biw=1470&bih=794&tbm=lcl&sxsrf=ADLYWIIlrWe2iE7Vtk7ruWlCs2Hf_PULJA%3A1725831681379&ei=ARreZqH2Fua3wN4Pj_qb6Q8&ved=0ahUKEwjh-r2CqLSIAxXmG9AFHQ_9Jv0Q4dUDCAk&uact=5&oq=nori+sushi&gs_lp=Eg1nd3Mtd2l6LWxvY2FsIgpub3JpIHN1c2hpMhEQABiABBiRAhixAxiDARiKBTILEAAYgAQYkQIYigUyCxAAGIAEGJECGIoFMgsQABiABBiRAhiKBTILEAAYgAQYkQIYigUyChAAGIAEGBQYhwIyBRAAGIAEMgUQABiABDIFEAAYgAQyBRAAGIAESODGCVDnwAlYpsQJcAJ4AJABAJgBUqABkAOqAQE2uAEDyAEA-AEBmAIIoAKsA8ICBBAjGCfCAgoQABiABBhDGIoFwgIOEAAYgAQYkQIYsQMYigXCAggQABiABBixA5gDAIgGAZIHATigB8wh&sclient=gws-wiz-local#lkt=LocalPoiReviews&rlfi=hd:;si:;mv:[[43.53326486569146,-68.68894857684073],[38.121331789078,-74.40454943958922]]',
            name: 'Stella L.',
            star: 5,
            review: 'I am usually skeptical of sushi places in the shopping mall, but this little sushi place has been around for years, and never fail! Every time the food is fresh and rice is warm, and over the years they have added more items to their menu which all very good. We have ordered sushi rolls, poke bowls, bento boxes, etc., each and every one of them turns out to be tasty.'
          },
          {
            url: 'https://www.google.com/search?q=nori+sushi&sca_esv=c4c1450a5839235a&sca_upv=1&biw=1470&bih=794&tbm=lcl&sxsrf=ADLYWIIlrWe2iE7Vtk7ruWlCs2Hf_PULJA%3A1725831681379&ei=ARreZqH2Fua3wN4Pj_qb6Q8&ved=0ahUKEwjh-r2CqLSIAxXmG9AFHQ_9Jv0Q4dUDCAk&uact=5&oq=nori+sushi&gs_lp=Eg1nd3Mtd2l6LWxvY2FsIgpub3JpIHN1c2hpMhEQABiABBiRAhixAxiDARiKBTILEAAYgAQYkQIYigUyCxAAGIAEGJECGIoFMgsQABiABBiRAhiKBTILEAAYgAQYkQIYigUyChAAGIAEGBQYhwIyBRAAGIAEMgUQABiABDIFEAAYgAQyBRAAGIAESODGCVDnwAlYpsQJcAJ4AJABAJgBUqABkAOqAQE2uAEDyAEA-AEBmAIIoAKsA8ICBBAjGCfCAgoQABiABBhDGIoFwgIOEAAYgAQYkQIYsQMYigXCAggQABiABBixA5gDAIgGAZIHATigB8wh&sclient=gws-wiz-local#lkt=LocalPoiReviews&rlfi=hd:;si:;mv:[[43.53326486569146,-68.68894857684073],[38.121331789078,-74.40454943958922]]',
            name: 'Minfeng L.',
            star: 5,
            review: 'More than ten years old. Trustworthy. Choosing NORI Sushi will not disappoint me.'
          },
        ],
            // Add more fields like images, videos, menus, etc.
        },
        thewok360: {
          name: 'The Wok 360',
          description: 'A wonderful Thai cuisine experience.',
          videos: "",
          doordash: "https://order.online/store/the-wok-360-cabazon-28619408/?hideModal=true&pickup=true&redirected=true",
          locations: [
            { lat: 33.9286372, lng: -116.8142366, name: 'The Wok 360', address: '48400 Seminole Dr, Cabazon, CA 92230, USA' },
            { lat: 33.5453, lng: -82.1442, name: 'The Wok 360 Evans', address: '4469 Washington Rd, Evans, GA 30809, United States', doordash: 'https://www.doordash.com/store/the-wok-360-evans-44764957/?hideModal=true&pickup=true' },
{ lat: 35.3890, lng: -80.6227, name: 'The Wok 360 Concord', address: '150 Concord Commons Pl SW, Concord, NC 28027, United States', doordash: '' },
          ],
          menu: {
              ComboMeal: [
                {
                  name: 'Combo 1',
                  description: 'Any one entrée with one side',
                  detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
                  detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
                  price: 5.99,
                  image: 'path/to/spring-rolls.jpg'
                },
                {
                  name: 'Combo 2',
                  description: 'Any two entrée with one side',
                  detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
                  detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
                  price: 7.99,
                  image: 'path/to/satay-chicken.jpg'
                },
                {
                  name: 'Combo 3',
                  description: 'Any three entrée with one side',
                  detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
                  detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
                  price: 7.99,
                  image: 'path/to/satay-chicken.jpg'
                },
              ],
              ChefSpecial: [
                {
                  name: 'Chef\'s Special',
                  description: 'Any one entrée with one side and one egg roll',
                  price: 12.99,
                  image: 'path/to/pad-thai.jpg'
                },
              ],
              NoodleBar: [
                {
                  name: 'Tokatsu',
                  description: 'Ramen or Udon',
                  price: 6.99,
                  image: 'path/to/mango-sticky-rice.jpg'
                },
                {
                  name: 'Chicken',
                  description: 'Ramen or Udon',
                  price: 6.99,
                  image: 'path/to/mango-sticky-rice.jpg'
                },
                {
                  name: 'Beef',
                  description: 'Ramen or Udon',
                  price: 6.99,
                  image: 'path/to/mango-sticky-rice.jpg'
                },
                {
                  name: 'Seafood',
                  description: 'Ramen or Udon',
                  price: 6.99,
                  image: 'path/to/mango-sticky-rice.jpg'
                },
              ],
              Beverages: [
                  {
                    name: 'Milk Tea',
                    description: 'Taro Tea, Thai Tea, Creamy Coconut, Japanese Matcha, Black Milk Tea',
                    price: 6.99,
                    image: 'path/to/mango-sticky-rice.jpg'
                  },
                  {
                    name: 'Fruit Tea',
                    description: 'Mango Tea, Strawberry Tea, Passion Fruit Tea, Honey Lemon Tea',
                    price: 6.99,
                    image: 'path/to/mango-sticky-rice.jpg'
                  },
                  {
                    name: 'Soft Drinks',
                    description: '',
                    price: 6.99,
                    image: 'path/to/mango-sticky-rice.jpg'
                  },
                  {
                    name: 'Bottle Drinks',
                    description: '',
                    price: 6.99,
                    image: 'path/to/mango-sticky-rice.jpg'
                  },
              ],
              SideOrder: [
                  {
                    name: 'Spring Roll',
                    description: '',
                    price: 12.99,
                    image: 'path/to/pad-thai.jpg'
                  },
                                      {
                    name: 'Egg Roll',
                    description: '',
                    price: 13.99,
                    image: 'path/to/green-curry.jpg'
                  },
                  {
                    name: 'Crab Rangoon (4)',
                    description: '',
                    price: 13.99,
                    image: 'path/to/green-curry.jpg'
                  },
                  {
                    name: 'Fried Rice / Lo Mein',
                    description: 'Stir-fried Rice or Lo Mein noodles',
                    price: 12.99,
                    image: 'path/to/pad-thai.jpg'
                  },
                  {
                    name: 'Vegetables Entree',
                    description: 'Mixed Veggies',
                    price: 12.99,
                    image: 'path/to/pad-thai.jpg'
                  },
                  {
                    name: 'Single Entree',
                    description: 'Single Meat of Your Choice',
                    detailedDescription: 'Choice of Meat includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp',
                    price: 13.99,
                    image: 'path/to/green-curry.jpg'
                  },
                ],
            },
            review: [
              {
                url: 'https://www.yelp.com/biz/wok-360-cabazon', 
                name: 'Pam S.', 
                star: 5, 
                review: 'the teriyaki chicken is a favorite of mine & a few other non breaded chicken choices made my choice easy! Fast & easy service with flavorful food choices is the way to go here.'
              },

            ]
          // Add more fields like images, videos, menus, etc.
      },
      sakesushinramen: {
        name: 'Sake Sushi N Ramen',
        description: 'A wonderful Japanese cuisine experience.',
        videos: "",
        doordash: "https://order.online/business/sake-sushi-n-ramen-12788062",
        locations: [
          { lat: 33.9286372, lng: -116.8142366, name: 'The Wok 360', address: '48400 Seminole Dr, Cabazon, CA 92230, USA' },
        ],
        menu: {
            ComboMeal: [
              {
                name: 'Combo 1',
                description: 'Any one entrée with one side',
                detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
                detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
                price: 5.99,
                image: 'path/to/spring-rolls.jpg'
              },
              {
                name: 'Combo 2',
                description: 'Any two entrée with one side',
                detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
                detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
                price: 7.99,
                image: 'path/to/satay-chicken.jpg'
              },
              {
                name: 'Combo 3',
                description: 'Any three entrée with one side',
                detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
                detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
                price: 7.99,
                image: 'path/to/satay-chicken.jpg'
              },
            ],
            ChefSpecial: [
              {
                name: 'Chef\'s Special',
                description: 'Any one entrée with one side and one egg roll',
                price: 12.99,
                image: 'path/to/pad-thai.jpg'
              },
            ],
            NoodleBar: [
              {
                name: 'Tokatsu',
                description: 'Ramen or Udon',
                price: 6.99,
                image: 'path/to/mango-sticky-rice.jpg'
              },
              {
                name: 'Chicken',
                description: 'Ramen or Udon',
                price: 6.99,
                image: 'path/to/mango-sticky-rice.jpg'
              },
              {
                name: 'Beef',
                description: 'Ramen or Udon',
                price: 6.99,
                image: 'path/to/mango-sticky-rice.jpg'
              },
              {
                name: 'Seafood',
                description: 'Ramen or Udon',
                price: 6.99,
                image: 'path/to/mango-sticky-rice.jpg'
              },
            ],
            Beverages: [
                {
                  name: 'Milk Tea',
                  description: 'Taro Tea, Thai Tea, Creamy Coconut, Japanese Matcha, Black Milk Tea',
                  price: 6.99,
                  image: 'path/to/mango-sticky-rice.jpg'
                },
                {
                  name: 'Fruit Tea',
                  description: 'Mango Tea, Strawberry Tea, Passion Fruit Tea, Honey Lemon Tea',
                  price: 6.99,
                  image: 'path/to/mango-sticky-rice.jpg'
                },
                {
                  name: 'Soft Drinks',
                  description: '',
                  price: 6.99,
                  image: 'path/to/mango-sticky-rice.jpg'
                },
                {
                  name: 'Bottle Drinks',
                  description: '',
                  price: 6.99,
                  image: 'path/to/mango-sticky-rice.jpg'
                },
            ],
            SideOrder: [
                {
                  name: 'Spring Roll',
                  description: '',
                  price: 12.99,
                  image: 'path/to/pad-thai.jpg'
                },
                                    {
                  name: 'Egg Roll',
                  description: '',
                  price: 13.99,
                  image: 'path/to/green-curry.jpg'
                },
                {
                  name: 'Crab Rangoon (4)',
                  description: '',
                  price: 13.99,
                  image: 'path/to/green-curry.jpg'
                },
                {
                  name: 'Fried Rice / Lo Mein',
                  description: 'Stir-fried Rice or Lo Mein noodles',
                  price: 12.99,
                  image: 'path/to/pad-thai.jpg'
                },
                {
                  name: 'Vegetables Entree',
                  description: 'Mixed Veggies',
                  price: 12.99,
                  image: 'path/to/pad-thai.jpg'
                },
                {
                  name: 'Single Entree',
                  description: 'Single Meat of Your Choice',
                  detailedDescription: 'Choice of Meat includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp',
                  price: 13.99,
                  image: 'path/to/green-curry.jpg'
                },
              ],
          },
          review: [
            {
              url: 'https://www.yelp.com/biz/wok-360-cabazon', 
              name: 'Pam S.', 
              star: 5, 
              review: 'the teriyaki chicken is a favorite of mine & a few other non breaded chicken choices made my choice easy! Fast & easy service with flavorful food choices is the way to go here.'
            },

          ]
        // Add more fields like images, videos, menus, etc.
    },
    chinawok: {
      name: 'China Wok',
      description: 'A wonderful Chinese cuisine experience.',
      videos: "",
      doordash: "https://order.online/business/china-wok-brass-mill-mall-chinese-restaurant-11250058",
      locations: [
        { lat: 33.9286372, lng: -116.8142366, name: 'The Wok 360', address: '48400 Seminole Dr, Cabazon, CA 92230, USA' },
      ],
      menu: {
          ComboMeal: [
            {
              name: 'Combo 1',
              description: 'Any one entrée with one side',
              detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
              detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
              price: 5.99,
              image: 'path/to/spring-rolls.jpg'
            },
            {
              name: 'Combo 2',
              description: 'Any two entrée with one side',
              detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
              detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
              price: 7.99,
              image: 'path/to/satay-chicken.jpg'
            },
            {
              name: 'Combo 3',
              description: 'Any three entrée with one side',
              detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
              detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
              price: 7.99,
              image: 'path/to/satay-chicken.jpg'
            },
          ],
          ChefSpecial: [
            {
              name: 'Chef\'s Special',
              description: 'Any one entrée with one side and one egg roll',
              price: 12.99,
              image: 'path/to/pad-thai.jpg'
            },
          ],
          NoodleBar: [
            {
              name: 'Tokatsu',
              description: 'Ramen or Udon',
              price: 6.99,
              image: 'path/to/mango-sticky-rice.jpg'
            },
            {
              name: 'Chicken',
              description: 'Ramen or Udon',
              price: 6.99,
              image: 'path/to/mango-sticky-rice.jpg'
            },
            {
              name: 'Beef',
              description: 'Ramen or Udon',
              price: 6.99,
              image: 'path/to/mango-sticky-rice.jpg'
            },
            {
              name: 'Seafood',
              description: 'Ramen or Udon',
              price: 6.99,
              image: 'path/to/mango-sticky-rice.jpg'
            },
          ],
          Beverages: [
              {
                name: 'Milk Tea',
                description: 'Taro Tea, Thai Tea, Creamy Coconut, Japanese Matcha, Black Milk Tea',
                price: 6.99,
                image: 'path/to/mango-sticky-rice.jpg'
              },
              {
                name: 'Fruit Tea',
                description: 'Mango Tea, Strawberry Tea, Passion Fruit Tea, Honey Lemon Tea',
                price: 6.99,
                image: 'path/to/mango-sticky-rice.jpg'
              },
              {
                name: 'Soft Drinks',
                description: '',
                price: 6.99,
                image: 'path/to/mango-sticky-rice.jpg'
              },
              {
                name: 'Bottle Drinks',
                description: '',
                price: 6.99,
                image: 'path/to/mango-sticky-rice.jpg'
              },
          ],
          SideOrder: [
              {
                name: 'Spring Roll',
                description: '',
                price: 12.99,
                image: 'path/to/pad-thai.jpg'
              },
                                  {
                name: 'Egg Roll',
                description: '',
                price: 13.99,
                image: 'path/to/green-curry.jpg'
              },
              {
                name: 'Crab Rangoon (4)',
                description: '',
                price: 13.99,
                image: 'path/to/green-curry.jpg'
              },
              {
                name: 'Fried Rice / Lo Mein',
                description: 'Stir-fried Rice or Lo Mein noodles',
                price: 12.99,
                image: 'path/to/pad-thai.jpg'
              },
              {
                name: 'Vegetables Entree',
                description: 'Mixed Veggies',
                price: 12.99,
                image: 'path/to/pad-thai.jpg'
              },
              {
                name: 'Single Entree',
                description: 'Single Meat of Your Choice',
                detailedDescription: 'Choice of Meat includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp',
                price: 13.99,
                image: 'path/to/green-curry.jpg'
              },
            ],
        },
        review: [
          {
            url: 'https://www.yelp.com/biz/wok-360-cabazon', 
            name: 'Pam S.', 
            star: 5, 
            review: 'the teriyaki chicken is a favorite of mine & a few other non breaded chicken choices made my choice easy! Fast & easy service with flavorful food choices is the way to go here.'
          },

        ]
      // Add more fields like images, videos, menus, etc.
  },
  stirfry88: {
    name: 'Stir Fry 88',
    description: 'A wonderful Wok experience.',
    videos: "",
    doordash: "https://order.online/business/stir-fry-88-11518986",
    locations: [
      { lat: 33.9286372, lng: -116.8142366, name: 'The Wok 360', address: '48400 Seminole Dr, Cabazon, CA 92230, USA' },
    ],
    menu: {
        ComboMeal: [
          {
            name: 'Combo 1',
            description: 'Any one entrée with one side',
            detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
            detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
            price: 5.99,
            image: 'path/to/spring-rolls.jpg'
          },
          {
            name: 'Combo 2',
            description: 'Any two entrée with one side',
            detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
            detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
            price: 7.99,
            image: 'path/to/satay-chicken.jpg'
          },
          {
            name: 'Combo 3',
            description: 'Any three entrée with one side',
            detailedDescription: 'Choice of Entrée includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp, Mixed Vegetables',
            detailedDescription2: 'Choice of Side includes: Lo Mein, Fried Rice, White Rice',
            price: 7.99,
            image: 'path/to/satay-chicken.jpg'
          },
        ],
        ChefSpecial: [
          {
            name: 'Chef\'s Special',
            description: 'Any one entrée with one side and one egg roll',
            price: 12.99,
            image: 'path/to/pad-thai.jpg'
          },
        ],
        NoodleBar: [
          {
            name: 'Tokatsu',
            description: 'Ramen or Udon',
            price: 6.99,
            image: 'path/to/mango-sticky-rice.jpg'
          },
          {
            name: 'Chicken',
            description: 'Ramen or Udon',
            price: 6.99,
            image: 'path/to/mango-sticky-rice.jpg'
          },
          {
            name: 'Beef',
            description: 'Ramen or Udon',
            price: 6.99,
            image: 'path/to/mango-sticky-rice.jpg'
          },
          {
            name: 'Seafood',
            description: 'Ramen or Udon',
            price: 6.99,
            image: 'path/to/mango-sticky-rice.jpg'
          },
        ],
        Beverages: [
            {
              name: 'Milk Tea',
              description: 'Taro Tea, Thai Tea, Creamy Coconut, Japanese Matcha, Black Milk Tea',
              price: 6.99,
              image: 'path/to/mango-sticky-rice.jpg'
            },
            {
              name: 'Fruit Tea',
              description: 'Mango Tea, Strawberry Tea, Passion Fruit Tea, Honey Lemon Tea',
              price: 6.99,
              image: 'path/to/mango-sticky-rice.jpg'
            },
            {
              name: 'Soft Drinks',
              description: '',
              price: 6.99,
              image: 'path/to/mango-sticky-rice.jpg'
            },
            {
              name: 'Bottle Drinks',
              description: '',
              price: 6.99,
              image: 'path/to/mango-sticky-rice.jpg'
            },
        ],
        SideOrder: [
            {
              name: 'Spring Roll',
              description: '',
              price: 12.99,
              image: 'path/to/pad-thai.jpg'
            },
                                {
              name: 'Egg Roll',
              description: '',
              price: 13.99,
              image: 'path/to/green-curry.jpg'
            },
            {
              name: 'Crab Rangoon (4)',
              description: '',
              price: 13.99,
              image: 'path/to/green-curry.jpg'
            },
            {
              name: 'Fried Rice / Lo Mein',
              description: 'Stir-fried Rice or Lo Mein noodles',
              price: 12.99,
              image: 'path/to/pad-thai.jpg'
            },
            {
              name: 'Vegetables Entree',
              description: 'Mixed Veggies',
              price: 12.99,
              image: 'path/to/pad-thai.jpg'
            },
            {
              name: 'Single Entree',
              description: 'Single Meat of Your Choice',
              detailedDescription: 'Choice of Meat includes: Mango Chicken, Bang Bang Chicken, Mongolian Beef, Red Chili Chicken, Coconut Chicken, Honey Chicken, Thai Spicy Chicken, Thai Chicken W. Broccoli, Jalapeno Shrimp',
              price: 13.99,
              image: 'path/to/green-curry.jpg'
            },
          ],
      },
      review: [
        {
          url: 'https://www.yelp.com/biz/wok-360-cabazon', 
          name: 'Pam S.', 
          star: 5, 
          review: 'the teriyaki chicken is a favorite of mine & a few other non breaded chicken choices made my choice easy! Fast & easy service with flavorful food choices is the way to go here.'
        },

      ]
    // Add more fields like images, videos, menus, etc.
},
    

        // Add more restaurants as needed
    };

    return (
        <RestaurantsContext.Provider value={{ restaurantData, setRestaurantData, restaurants }}>
            {children}
        </RestaurantsContext.Provider>
    );
};

export default RestaurantsProvider;